$(document).on('turbolinks:load', function () {

  // クリップボードにコピーして、ボタンテキストを「コピーしました！」に変える
  // $('.xxx-btn').on('click', function() {
  //   var textToCopy = $(this).data('copy-text');
  //   var $button = $(this);
  //   var $span = $button.find('span');
  //   var originalText = $span.text();

  //   // クリップボードにコピー
  //   if (navigator.clipboard) {
  //     navigator.clipboard.writeText(textToCopy).then(function() {
  //       // コピー成功時の処理
  //       $span.text('コピーしました！');
  //       $button.css('background-color', '#28a745');
        
  //       // 2秒後に元のテキストに戻す
  //       setTimeout(function() {
  //         $span.text(originalText);
  //         $button.css('background-color', '');
  //       }, 2000);
  //     }).catch(function(err) {
  //       // コピー失敗時の処理
  //       console.error('コピーに失敗しました:', err);
  //       alert('コピーに失敗しました。手動でコピーしてください。');
  //     });
  //   } else {
  //     // navigator.clipboardがサポートされていない場合の代替手段
  //     var tempInput = document.createElement('input');
  //     tempInput.value = textToCopy;
  //     document.body.appendChild(tempInput);
  //     tempInput.select();
  //     document.execCommand('copy');
  //     document.body.removeChild(tempInput);
      
  //     // コピー成功時の処理
  //     $span.text('コピーしました！');
  //     $button.css('background-color', '#28a745');
      
  //     // 2秒後に元のテキストに戻す
  //     setTimeout(function() {
  //       $span.text(originalText);
  //       $button.css('background-color', '');
  //     }, 2000);
  //   }
  // });
})
